import * as yup from "yup";

import { BONUSCARD_DISCOUNT_PREFIX } from "@/utils/validation/config";
import * as RHFBonusCardValidationRules from "@/utils/validation/schemas/bonusCard.RHF";
import { recaptcha } from "@/utils/validation/schemas/general.RHF";
import * as RHFGiftCardValidationRules from "@/utils/validation/schemas/giftCard.RHF";

export const CheckoutGiftCardFormValidationSchema = yup.object({
    cardCode: RHFGiftCardValidationRules.giftCard,
    bonusCard: yup
        .object({
            number: RHFBonusCardValidationRules.bonusCard
        })
        .optional()
        .default(undefined)
        .when("cardCode", {
            is: (cardCode?: string | null) =>
                (cardCode || "").startsWith(BONUSCARD_DISCOUNT_PREFIX),
            then: (schema) => schema.required(),
            otherwise: (schema) => schema.optional()
        }),
    recaptcha: recaptcha
});

export type CheckoutGiftCardFormValues = yup.InferType<
    typeof CheckoutGiftCardFormValidationSchema
>;
